import { windowChangeEmitter } from "@/utils/emitter";
import { useStorage } from "@vueuse/core";
export const collapsed = useStorage("COLLAPSED", false);
const minWidth = 80;
const maxWidth = 200;
export const getRightSize = (store) => {
  const leftWidth = collapsed.value ? minWidth : maxWidth;
  const rightHeight = window.innerHeight - 93;
  const rightWidth = window.innerWidth - leftWidth;
  const tmp = {
    rightHeight,
    rightWidth,
    height: window.innerHeight,
    tableHeight: window.innerHeight,
  };
  store.commit("user/SET_WINDOWSIZE", tmp);
  windowChangeEmitter.emit("window-change", tmp);
};
